var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from './utils/axios';
import { downloadFile } from './utils/utils';
export function getClient(ClientId) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/client/get?ClientId=' + (ClientId ? ClientId : ''))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getClientListe(_a) {
    var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.itemByPage, itemByPage = _c === void 0 ? 10 : _c, _d = _a.filtres, filtres = _d === void 0 ? null : _d, _e = _a.order, order = _e === void 0 ? null : _e;
    return __awaiter(this, void 0, void 0, function () {
        var params, data;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    params = __assign({}, filtres);
                    params.Page = page;
                    params.ItemByPage = itemByPage;
                    if (order && order.by) {
                        params[order.isAsc ? 'OrderBy' : 'OrderByDesc'] = order.by;
                    }
                    return [4 /*yield*/, axios.get('/client/liste', {
                            params: params,
                        })];
                case 1:
                    data = (_f.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function postClient(IdClient, client) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/client/store', {
                        client: __assign(__assign({}, client), { IdClient: IdClient }),
                    })];
                case 1:
                    data = (_a.sent()).data;
                    if (!IdClient && data.IdClient) {
                        window.location.href = "/client/fiche/".concat(data.IdClient);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function postNoteClient(ClientId, Note) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/client/store/note', {
                        ClientId: ClientId,
                        Note: Note,
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, { isOk: data.type !== 'error' }];
            }
        });
    });
}
export function deleteClient(ClientId) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.delete('/client/delete?ClientId=' + ClientId)];
                case 1:
                    data = (_a.sent()).data;
                    if (data && data.isDeleted) {
                        window.location.href = '/client';
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function exportClient(filtres) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/client/export', {
                        params: filtres,
                    })];
                case 1:
                    data = (_a.sent()).data;
                    downloadFile({ data: data, fileName: 'clients', fileType: 'text/csv' });
                    return [2 /*return*/];
            }
        });
    });
}
export function getClientEquipeListe(ClientId) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/client/equipe?ClientId=' + ClientId)];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function postClientEquipe(ClientId, CollaborateurId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (CollaborateurId == null) {
                        return [2 /*return*/, axios.get('/utils/error?Message=Veuillez sélectionner un collaborateur.')];
                    }
                    return [4 /*yield*/, axios.post('/client/equipe/store', {
                            ClientId: ClientId,
                            CollaborateurId: CollaborateurId,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function deleteClientEquipe(IdClientCollaborateur) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.delete('/client/equipe/delete?IdClientCollaborateur=' + IdClientCollaborateur)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function reaffectation(_a) {
    var CollaborateurIdDeleted = _a.CollaborateurIdDeleted, CollaborateurIdAdded = _a.CollaborateurIdAdded, ClientIds = _a.ClientIds;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, axios.post('/client/equipe/reaffectation', {
                        CollaborateurIdDeleted: CollaborateurIdDeleted,
                        CollaborateurIdAdded: CollaborateurIdAdded,
                        ClientIds: ClientIds
                    })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=client.js.map